module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav"
  }, [_c('div', {
    staticClass: "sub-nav--inner"
  }, [_c('ul', {
    directives: [{
      name: "menu-aim",
      rawName: "v-menu-aim",
      value: (_vm.menuAim),
      expression: "menuAim"
    }],
    staticClass: "u-reset sub-nav--list"
  }, _vm._l((_vm.child.children), function(item, idx) {
    return _c('li', {
      staticClass: "sub-nav--item"
    }, [_c('cmp-sub-nav-item', {
      ref: "row",
      refInFor: true,
      staticClass: "sub-nav--el",
      attrs: {
        "facet": "sub-nav",
        "level": 1,
        "child": item,
        "idx": idx
      }
    })], 1)
  })), _vm._v(" "), _c('cmp-sub-nav-flyout', {
    staticClass: "sub-nav--flyout",
    attrs: {
      "level": 1,
      "is-fixed": _vm.isFixed
    }
  }), _vm._v(" "), _c('cmp-sub-nav-flyout', {
    staticClass: "sub-nav--final-row",
    attrs: {
      "level": 2,
      "is-fixed": _vm.isFixed
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c86fabd2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c86fabd2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/sub-nav/index.vue
// module id = 584
// module chunks = 7